import { AddCircleOutline, HighlightOff, Info } from "@mui/icons-material";

const Color = ({ variants, setVariants }) => {
  return (
    <div>
      {" "}
      <div className="rounded-lg bg-white py-3 h-fit border border-[#E1E6E1] m-3">
        <div className="flex justify-between items-center gap-[10px] px-3">
          <div className="flex flex-col gap-1">
            <p className="text-[#2E332F] font-semibold text-sm leading-[18px]">
              Color
            </p>
            <div className="flex gap-1 items-center">
              <Info style={{ color: "#0066AF", fontSize: "16px" }} />
              <p className="text-[#96A397] font-medium text-sm leading-[18px]">
                Black,Blue,Red
              </p>
            </div>
          </div>

          <HighlightOff
            style={{
              color: "#96A397",
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={() =>
              setVariants((prev) => ({
                ...prev,
                colour: {
                  values: [""],
                  custom: false,
                },
              }))
            }
          />
        </div>
        <div className="bg-[#E1E6E1] my-2 h-[1.2px] w-full" />
        {/* VARIANT OPTIONS */}

        <div className="m-3 bg-white border rounded-lg border-[#E1E6E1]">
          <div className="border-b border-b-[#E1E6E1]">
            <p className="text-[#3E473F] font-semibold text-sm leading-[18px] p-3">
              Variant options
            </p>
          </div>
          <div className="px-3">
            <div>
              {variants?.colour?.values?.map((color, index) => (
                <div
                  key={index}
                  className="relative w-full py-3 flex items-center gap-2"
                >
                  <input
                    type="text"
                    className="border border-[#E1E6E1] rounded-[8px] h-[44px] px-3 w-full text-sm outline-none focus:border-[#2B8C34]"
                    placeholder={`Enter color`}
                    value={color}
                    onChange={(e) => {
                      const newColors = [...variants.colour.values];
                      newColors[index] = e.target.value;
                      setVariants({
                        ...variants,
                        colour: { ...variants.colour, values: newColors },
                      });
                    }}
                  />
                  {index > 0 && (
                    <HighlightOff
                      style={{
                        color: "#96A397",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const newColors = variants.colour.values.filter(
                          (_, idx) => idx !== index
                        );
                        setVariants({
                          ...variants,
                          colour: { ...variants.colour, values: newColors },
                        });
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          <div
            className={`border-t border-t-[#E1E6E1] flex items-center gap-1 p-3 group ${
              !variants.colour.values[variants.colour.values.length - 1] ||
              String(
                variants.colour.values[variants.colour.values.length - 1] || ""
              ).trim() === ""
                ? "opacity-50 cursor-not-allowed"
                : "cursor-pointer hover:bg-[#EDF7EE]"
            }`}
            onClick={() => {
              if (
                variants.colour.values[variants.colour.values.length - 1] &&
                String(
                  variants.colour.values[variants.colour.values.length - 1] ||
                    ""
                ).trim() !== ""
              ) {
                setVariants({
                  ...variants,
                  colour: {
                    ...variants.colour,
                    values: [...(variants.colour?.values || []), ""],
                  },
                });
              }
            }}
            aria-disabled={
              !variants.colour.values[variants.colour.values.length - 1] ||
              String(
                variants.colour.values[variants.colour.values.length - 1] || ""
              ).trim() === ""
            }
          >
            <AddCircleOutline style={{ fontSize: "20px", color: "#2B8C34" }} />
            <p className="text-[#2B8C34] font-semibold text-sm leading-[18px]">
              Add More
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Color;
